<div class="card">
    <app-novo-pedido-outros-servicos [legend]="'Itens'" [comboOutrosServicos]="comboOutrosServicos" [servicosAdicionados]="servicosAdicionados"></app-novo-pedido-outros-servicos>
</div>